import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent, TextAreaComponent } from '@pure/hive';
import { FeedbackState, IChatFeedbackRequest, IConversationMessage, MessageFeedback } from '../../model/conversation';
import { faXmark } from '@fortawesome/pro-light-svg-icons';

const FEEDBACK_MAX_TEXT_LENGTH = 1000;

@Component({
    selector: 'copilot-message-feedback',
    standalone: true,
    imports: [FormsModule, ButtonComponent, TextAreaComponent],
    templateUrl: './message-feedback.component.html',
    styleUrl: './message-feedback.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageFeedbackComponent implements OnChanges {
    @Input() message!: IConversationMessage;
    @Input() feedback!: MessageFeedback;
    @Input() sessionId!: string;
    @Output() feedbackClose: EventEmitter<FeedbackState> = new EventEmitter<FeedbackState>();
    @Output() feedbackSubmit: EventEmitter<IChatFeedbackRequest> = new EventEmitter<IChatFeedbackRequest>();

    additionalDetailsText = '';
    readonly MAX_TEXT_LENGTH = FEEDBACK_MAX_TEXT_LENGTH;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['message']) {
            this.additionalDetailsText = '';
        }
    }

    closeAdditionalDetails(): void {
        this.feedbackClose.emit('success');
    }

    isSubmitDisabled(): boolean {
        return this.additionalDetailsText.length === 0 || this.additionalDetailsText.length > this.MAX_TEXT_LENGTH;
    }

    clickSubmit(): void {
        const feedbackRequest: IChatFeedbackRequest = {
            message_id: this.message.variations[this.message.selectedVariationIndex].uuid,
            session_id: this.sessionId,
            score: this.feedback,
            feedback: this.additionalDetailsText,
        };

        this.feedbackSubmit.emit(feedbackRequest);
    }

    protected readonly faXmark = faXmark;
}
